import React, { useState } from "react";
import UploadImage from "./UploadImage";
import axios from "axios";
import "../styles/Edit.css";
import backendUrl from "../BackendUrl";

const TrimColorsManager = ({ trimId, trimColors, onUpdate }) => {
  const [isCanvasOpen, setCanvasOpen] = useState(false);
  const [selectedColorIndex, setSelectedColorIndex] = useState(null);
  const [colorData, setColorData] = useState({ color: "", colorImg: "" });
  const [isNewColor, setIsNewColor] = useState(false);
  const adminToken = localStorage.getItem('adminToken');

  const openCanvas = () => {
    setCanvasOpen(true);
  };

  const closeCanvas = () => {
    setCanvasOpen(false);
    setSelectedColorIndex(null);
    setColorData({ color: "", colorImg: "" });
    setIsNewColor(false);
  };

  const handleSelectChange = (e) => {
    const value = e.target.value;
    if (value === "new") {
      // Adding a new color (only the name)
      setIsNewColor(true);
      setSelectedColorIndex(null);
      setColorData({ color: "", colorImg: "" });
    } else {
      // Editing an existing color
      setIsNewColor(false);
      const index = parseInt(value, 10);
      setSelectedColorIndex(index);
      const existingColor = trimColors[index];
      setColorData({
        color: existingColor.color || "",
        colorImg: existingColor.colorImg || "",
      });
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setColorData((prev) => ({ ...prev, [name]: value }));
  };

  // Handle saving the color name (for both adding and editing)
  const handleNameSubmit = async () => {
    if (!colorData.color.trim()) {
      alert("Please enter a valid color name.");
      return;
    }
    try {
      let response;
      let updatedColors;
      if (isNewColor) {
        // Create a new color object and post it
        const newColor = { color: colorData.color, colorImg: "" };
        response = await axios.post(
          `${backendUrl}/api/vehicles/add-trim-color/${trimId}`,
          { colors: [newColor] }, {headers: {Authorization: `Bearer ${adminToken}`,},}
        );
        // Assume API returns updated trim with colors array
        updatedColors = response.data.trim.colors;
      } else {
        // Update the color name of an existing color
        const updatedColor = { color: colorData.color, colorImg: colorData.colorImg };
        updatedColors = trimColors.map((c, index) =>
          index === selectedColorIndex ? updatedColor : c
        );
        const colorId = trimColors[selectedColorIndex]._id;
        response = await axios.put(
          `${backendUrl}/api/vehicles/update-trim-color/${trimId}/${colorId}`,
          { colors: updatedColors }, {headers: {Authorization: `Bearer ${adminToken}`,},}
        );
        updatedColors = response.data.trim.colors;
      }
      onUpdate(updatedColors);
      closeCanvas();
      alert(isNewColor ? "Color added successfully!" : "Color name updated successfully!");
    } catch (error) {
      console.error(error);
      alert("Failed to save color changes. Please try again.");
    }
  };

  // Delete the color (and its image) via the API
  const handleColorDelete = async () => {
    if (!window.confirm("Are you sure you want to delete this color?")) return;
    try {
      const colorId = trimColors[selectedColorIndex]._id;
      const response = await axios.delete(
        `${backendUrl}/api/vehicles/delete-trim-color/${trimId}/${colorId}`, {headers: {Authorization: `Bearer ${adminToken}`,},}
      );
      // Assume API returns updated trim with colors array
      const updatedColors = response.data.trim.colors;
      onUpdate(updatedColors);
      closeCanvas();
      alert("Color deleted successfully!");
    } catch (error) {
      console.error(error);
      alert("Failed to delete color. Please try again.");
    }
  };

  return (
    <div className="color-manager">
      <h3>Colors</h3>
      <button type="button" onClick={openCanvas}>
        Add / Edit Color
      </button>

      {isCanvasOpen && (
        <div className="canvas-overlay">
          <div className="canvas">
            <h2>{isNewColor ? "Add New Color" : "Edit Color"}</h2>

            {/* Dropdown for selecting an existing color or adding a new one */}
            <label>
              Select Color:
              <select
                onChange={handleSelectChange}
                value={selectedColorIndex !== null ? selectedColorIndex : isNewColor ? "new" : ""}
              >
                <option value="">Select a color...</option>
                {trimColors.map((c, index) => (
                  <option key={index} value={index}>
                    {c.color || `Color ${index + 1}`}
                  </option>
                ))}
                <option value="new">+ Add New Color</option>
              </select>
            </label>

            {/* Input field for color name */}
            {(isNewColor || selectedColorIndex !== null) && (
              <>
                <label>
                  Color Name:
                  <input
                    type="text"
                    name="color"
                    value={colorData.color}
                    onChange={handleInputChange}
                  />
                </label>

                {/* Show preview if an image URL exists */}
                {colorData.colorImg && (
                  <div className="color-image-preview">
                    <img src={colorData.colorImg} alt="Color" style={{ width: "100px" }} />
                  </div>
                )}

                {/* When editing an existing color, show UploadImage to update the image */}
                {!isNewColor && selectedColorIndex !== null && (
                  <>
                    <h4>Upload Color Image</h4>
                    <UploadImage
                      uploadUrl="/api/vehicles/upload-color"
                      id={{ trimId: trimId, colorId: trimColors[selectedColorIndex]._id }}
                      onUploadSuccess={(data) => console.log("Uploaded trim image:", data)}
                    />
                  </>
                )}

                <div className="canvas-buttons">
                  <button type="button" onClick={handleNameSubmit}>
                    {isNewColor ? "Add Color" : "Update Color Name"}
                  </button>
                  {/* Render delete button only when editing an existing color */}
                  {!isNewColor && selectedColorIndex !== null && (
                    <button type="button" onClick={handleColorDelete}>
                      Delete Color
                    </button>
                  )}
                  <button type="button" onClick={closeCanvas}>
                    Cancel
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default TrimColorsManager;